module.exports = __webpack_public_path__ + "static/media/31JFA11.cb2c9430.jpg";